import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { withStyles } from "@material-ui/core";
import { Cookies } from "react-cookie";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Redirect } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import JDate from "jalali-date";
import FloatingLabelInput from "./FloatingLabelInput";
import Avatar from "@material-ui/core/Avatar";
import * as constants from "../constants";
import Divider from "@material-ui/core/Divider";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { Multiselect } from "multiselect-react-dropdown";
import Moment from "moment";
import NumberFormat from "react-number-format";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import Select from "react-select";
import ImageUploader from "react-images-upload";
import LinearProgress from "@material-ui/core/LinearProgress";
import { $POST } from "./../func";
import Switch from "@material-ui/core/Switch";
import Collapse from "@material-ui/core/Collapse";

import "react-modern-calendar-datepicker/lib/DatePicker.css";
import Calendar from "react-modern-calendar-datepicker";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import ReactExport from "react-data-export";
import { Lightbox } from "react-modal-image";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const styleselect = {
  multiselectContainer: {
    // To change css for multiselect (Width,height,etc..)
    fontSize: "14px",
    border: "1.25px solid #bababa",
    borderRadius: "4px",
  },
  searchBox: {
    // To change search box element look
    fontSize: "14px",
    minheight: "50px",
    textAlign: "right",
  },
  inputField: {
    // To change input field position or margin
    margin: "5px",
    fontSize: "14px",
  },
  chips: {
    // To change css chips(Selected options)
    //  background: '#00000000',
    border: "2px solid",
    fontSize: "14px",
  },
  optionContainer: {
    // To change css for option container
    textAlign: "right",
  },
  option: {
    // To change css for dropdown options
    fontSize: "14px",
    textAlign: "right",
  },
  groupHeading: {
    // To chanage group heading style
  },
};
const styles = (theme) => ({
  paperrtl: {
    marginTop: theme.spacing(0),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(1),
      width: theme.spacing(20),
    },
  },
  root: {
    width: "100%",
    margin: "15px",
    padding: "8px",
    direction: "rtl",
  },
  container: {
    maxHeight: 400,
  },
  select: {
    searchBox: {
      // To change search box element look
      border: "none",
      fontSize: "35px",
      minheight: "50px",
    },
    inputField: {
      // To change input field position or margin
      margin: "5px",
    },
    chips: {
      // To change css chips(Selected options)
      background: "red",
    },
    optionContainer: {
      // To change css for option container
      border: "2px solid",
    },
    option: {
      // To change css for dropdown options
      color: "blue",
    },
  },
});

class ChangeSendRequestPosted extends Component {
  cookies = new Cookies();

  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      errstr: "",
      errstatus: false,
      okstatus: false,
      requestinfos: [],
      requestinfofilter: [],
      rowsPerPage: 10,
      page: 0,
      showPaperDetail: false,
      archiveDetail: [],
      orderBy: "request_id",
      order: "desc",
      options: [],
      optionFieldInsurance: [],
      optionCompany: [],
      optionCity: [],
      optionState: [],
      selectedFieldInsurance: [],
      selectedCompany: [],
      selectedCity: [],
      selectedState: [],
      selectedDayEnd: "",
      selectedDayStart: "",
      dataChart: [],
      mobileAgentFilter: "",
      mobileUsertFilter: "",
      requestIdFilter: "",
      optionModeDelivery: "",
      selectedModeDelivery: "",

      optionState2: "",
      selectedState2: "",
      optionCity2: "",
      selectedCity2: "",
      resource: "",
      picturesRequestReady: "",
      loading: false,
      percent: 0,

      urlToLargeImageFile: "",
      urlToHugeImageFile: "",
      descImageFile: "",
      openImageBox: false,
    };
  }
  // -------------------------------------------------------------------------------------------
  async componentDidMount() {
    if (this.cookies.get("employee_token_str")) {
      this.props.props.props.dispatch({
        type: "WAITSHOW",
      });
      var self = this;
      const response = await $POST("employeelogin?command=checkemployeelogin");
      const arr = response.data;
      if (response.status == 200) {
        if (arr.result === 'ok') {
          self.getOrder();
        } else if (arr.result === "error") {
          self.setState({ redirect: true });
        }
        self.props.props.props.dispatch({
          type: "WITEHIDE",
        });
      }
    } else {
      this.setState({ redirect: true });
    }
  }

  // -------------------------------------------------------------------------------------------------------------
  async getOrder() {
    const { rowsPerPage, page } = this.state;
    this.props.props.props.dispatch({
      type: "WAITSHOW",
    });
    var self = this;

    const response =
      await $POST(`employeerequestreport?command=get_request&request_last_state_id=11&limit=${rowsPerPage}&
    offset=${page * rowsPerPage}
    `);
    const arr = response.data;
    if (response.status == 200) {
      if (arr.result === 'ok') {
        self.setState(
          {
            requestinfos: arr.data,
            requestinfofilter: arr.data,
            arrCount: arr.cnt,
          },
          () => {
            self.getFieldInsurance();
            self.getCompany();
            self.getState();
            self.getoptionModeDeliveryID();
          }
        );
      } else if (arr.result === "error") {
      }
      self.props.props.props.dispatch({
        type: "WITEHIDE",
      });
    }
  }

  // ----------------------------------------------------------------------------------------------------------------
  async getoptionModeDeliveryID() {
    //  $post
    var self = this;
    const response = await $POST(
      "employeerequestreport?command=get_mode_delivery"
    );
    const arr = response.data;
    if (response.status == 200) {
      if (arr.result === 'ok') {
        var State = [];
        for (var k = 0; k < arr.data.length; k++) {
          State.push({
            value: arr.data[k].delivery_mode_id,
            label: arr.data[k].delivery_mode_name,
          });
        }
        self.setState({ optionModeDelivery: State });
      } else if (arr.result === "error") {
        self.setState({
          snackstr: arr.desc,
          showSnack: true,
          snackMode: "error",
        });
      }
    }
  }

  // ------------------------------------------------------------------------------------------------------

  async getoptionCityID2() {
    // $post
    var self = this;
    const response = await $POST(
      `statecity?command=get_city&state_id=${this.state.selectedState2.value}`
    );
    const arr = response.data;
    if (response.status == 200) {
      if (arr.result === 'ok') {
        var State = [];

        for (var k = 0; k < arr.data.length; k++) {
          State.push({
            value: arr.data[k].city_id,
            label: arr.data[k].city_name,
          });
        }
        self.setState({ optionCity2: State });
      } else if (arr.result === "error") {
        self.setState({
          snackstr: arr.desc,
          showSnack: true,
          snackMode: "error",
        });
      }
    }
  }

  // --------------------------------------------------------------------------------------------------------------------------

  async getFieldInsurance() {
    // $post
    this.props.props.props.dispatch({
      type: "WAITSHOW",
    });
    var self = this;
    const response = await $POST(
      `employeerequestreport?command=get_fieldinsurance`
    );
    const arr = response.data;

    if (response.status == 200) {
      if (arr.result === 'ok') {
        var i,
          temp,
          temparray = [];

        self.setState({ optionFieldInsurance: arr.data }, () => {});
      }
      self.props.props.props.dispatch({
        type: "WITEHIDE",
      });
    }
  }

  // ----------------------------------------------------------------
  async getCompany() {
    // $post
    this.props.props.props.dispatch({
      type: "WAITSHOW",
    });
    var self = this;
    const response = await $POST(`company?command=get_company`);
    const arr = response.data;
    if (response.status == 200) {
      if (arr.result === 'ok') {
        self.setState({ optionCompany: arr.data }, () => {});
      } else if (arr.result === "error") {
      }
      self.props.props.props.dispatch({
        type: "WITEHIDE",
      });
    }
  }

  // ------------------------------------------------------------------------------------------------

  async getState() {
    //   $post
    this.props.props.props.dispatch({
      type: "WAITSHOW",
    });
    var self = this;
    const response = await $POST(`statecity?command=get_state`);
    const arr = response.data;

    if (response.status == 200) {
      if (arr.result === 'ok') {
        var State2 = [];

        for (var k = 0; k < arr.data.length; k++) {
          State2.push({
            value: arr.data[k].state_id,
            label: arr.data[k].state_name,
          });
        }
        self.setState(
          { optionState2: State2, optionState: arr.data },
          () => {}
        );
      } else if (arr.result === "error") {
      }
      self.props.props.props.dispatch({
        type: "WITEHIDE",
      });
    }
  }

  getOptionFilterCity() {
    const { selectedState, optionState } = this.state;
    this.setState({ optionCity: [] }, () => {
      for (var i = 0; i < selectedState.length; i++) {
        this.getCity(selectedState[i].state_id);
      }
    });
  }

  handleState2 = (selectedState2) => {
    this.setState(
      { selectedState2: selectedState2, selectedCity2: null },
      () => {
        this.getoptionCityID2();
      }
    );
  };
  handleCity2 = (selectedCity2) => {
    this.setState({ selectedCity2: selectedCity2 });
  };
  handleChangeResorce = (event) => {
    this.setState({ resource: event.target.value });
  };

  onSelectPicRequest = (picture) => {
    this.setState({
      picturesRequestReady: picture[0],
    });
  };
  //   -----------------------------------------------------------------------------------------------
  async getCity(state_id) {
    //   $post
    var self = this;
    const response = await $POST(
      `statecity?command=get_city&state_id=${state_id}`
    );
    const arr = response.data;
    if (response.status == 200) {
      if (arr.result === 'ok') {
        var State;
        if (self.state.optionCity.length > 0) {
          var State = self.state.optionCity;
        } else {
          var State = [];
        }
        for (var k = 0; k < arr.data.length; k++) {
          State.push(arr.data[k]);
        }
        self.setState({ optionCity: State });
      } else if (arr.result === "error") {
        self.setState({
          snackstr: arr.desc,
          showSnack: true,
          snackMode: "error",
        });
      }
    }
  }
  // -----------------------------------------------------------------------------------------------------
  uploadPicDelivery = (event) => {
    const {
      archiveDetail,
      picturesRequestReady,
      selectedCity2,
      selectedModeDelivery,
    } = this.state;
    if (
      picturesRequestReady &&
      picturesRequestReady !== "" &&
      picturesRequestReady !== null &&
      selectedCity2 !== null &&
      selectedCity2 !== "" &&
      selectedModeDelivery !== null &&
      selectedModeDelivery !== ""
    ) {
      this.setState({
        loading: true,
        percent: 0,
      });

      var self = this;
      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          var arr = JSON.parse(this.responseText);

          if (arr.result === "ok") {
            self.changeSatus11(arr.data["image_code"]);
          } else if (arr.result === "error") {
          }
        }
      };
      var fd = new FormData();
      fd.append("command", "uptoabr");
      fd.append("image", picturesRequestReady);
      fd.append("image_name", "رسید تحویل");
      fd.append(
        "image_desc",
        "رسید تحویل سفارش شماره" + archiveDetail["request_id"]
      );
      fd.append("name", "");
      xhttp.upload.addEventListener(
        "progress",
        function (evt) {
          if (evt.lengthComputable) {
            var percentComplete = evt.loaded / evt.total;
            self.setState({
              percent: percentComplete * 100,
            });
          }
        },
        false
      );
      xhttp.open("POST", `${constants.BASE_URL}/image`);
      xhttp.send(fd);
    } else {
      this.setState({
        snackstr: "لطفا مشخصات و عکس رسید تحویل را وارد نمایید.",
        showSnack: true,
        snackMode: "error",
      });
    }
  };

  // -------------------------------------------------------------------------------------------------------------
 async changeSatus11 (image_code) {
    const {
      archiveDetail,
      selectedState2,
      selectedCity2,
      selectedModeDelivery,
      resource,
    } = this.state;

    this.props.props.props.dispatch({
      type: "WAITSHOW",
    });
    var self = this;
    const response = await $POST(
      `employeerequestreport?command=requestdelivered11&request_id=${archiveDetail["request_id"]}&request_delivered_dsc=${resource}&
      request_delivered_mode_id=${selectedModeDelivery.value}&request_delivered_receipt_image_code=${image_code}&
      request_delivered_state_id=${selectedState2.value}&request_delivered_city_id=${selectedCity2.value}
      `
    );
    const arr = response.data;
    if (response.status == 200) {
      if (arr.result === 'ok') {
        self.setState({
          snackstr: arr.desc,
          showSnack: true,
          snackMode: "success",
          showPaper: [true, false, false, false, false, false, false],
          showChangeStatus: [
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
          ],
        });
      } else if (arr.result === "error") {
        self.setState({
          snackstr: arr.desc,
          showSnack: true,
          snackMode: "error",
        });
      }
      self.props.props.props.dispatch({
        type: "WITEHIDE",
      });
    }
  };



  handleModeDelivery = (selectedModeDelivery) => {
    this.setState({ selectedModeDelivery: selectedModeDelivery });
  };

  createSortHandler = (field) => {
    if (this.state.orderBy === field) {
      if (this.state.order === "asc") {
        this.setState({ order: "desc" });
      } else {
        this.setState({ order: "asc" });
      }
    } else {
      this.setState({ orderBy: field, order: "asc" });
    }
    var arraytemp = [],
      i,
      j,
      temp,
      a,
      b;
    arraytemp = this.state.requestinfofilter;
    for (i = 0; i < arraytemp.length; i++) {
      for (j = 0; j < arraytemp.length - 1; j++) {
        a = arraytemp[j];
        b = arraytemp[j + 1];
        if (a[field] < b[field] && this.state.order === "asc") {
          temp = arraytemp[j];
          arraytemp[j] = arraytemp[j + 1];
          arraytemp[j + 1] = temp;
        } else if (a[field] > b[field] && this.state.order === "desc") {
          temp = arraytemp[j];
          arraytemp[j] = arraytemp[j + 1];
          arraytemp[j + 1] = temp;
        }
      }
    }
  };
  handleChangeRowsPerPage = (event) => {
    this.setState(
      { rowsPerPage: parseInt(event.target.value), page: 0 },
      () => {
        this.getOrder();
      }
    );
  };

  handleSelectRows = (request_id, row) => {
    console.log(row);
    var request_delivered = null;
    if (row["request_delivered"]) {
      request_delivered = row["request_delivered"][0];

      this.setState({
        showPaperDetail: true,
        archiveDetail: row,
        selectedCity2: {
          value: request_delivered["request_delivered_state_id"],
          label: request_delivered["request_delivered_state"],
        },
        selectedState2: {
          value: request_delivered["request_delivered_city_id"],
          label: request_delivered["request_delivered_city"],
        },
        selectedModeDelivery: {
          value: request_delivered["request_delivered_mode_id"],
          label: request_delivered["request_delivered_mode"],
        },
        resource: request_delivered["request_delivered_dsc"],
      });
    }
  };

//   ------------------------------------------------------------------------------------------------
  async handleSelectRows(request_id, row) {
    var self = this;
    const response = await $POST(
      `employeerequestreport?command=getrequestbyid&request_id=${row.request_id}`
    );
    const arr = response.data;
      if (response.status == 200) {
        if (arr.result === 'ok') {
          var request = arr.data[0];

          var request_delivered = null;
          if (request["request_delivered"]) {
            request_delivered = request["request_delivered"][0];

            self.setState({
              showPaperDetail: true,
              archiveDetail: request,
              selectedCity2: {
                value: request_delivered["request_delivered_state_id"],
                label: request_delivered["request_delivered_state"],
              },
              selectedState2: {
                value: request_delivered["request_delivered_city_id"],
                label: request_delivered["request_delivered_city"],
              },
              selectedModeDelivery: {
                value: request_delivered["request_delivered_mode_id"],
                label: request_delivered["request_delivered_mode"],
              },
              resource: request_delivered["request_delivered_dsc"],
            });
          }
        } else if (arr.result === "error") {
          self.setState({
            snackstr: arr.desc,
            showSnack: true,
            snackMode: "error",
          });
        }
      }

  };



  hidePaperDetail = (event) => {
    this.setState({ showPaperDetail: false });
  };

  onSelectOptionFieldInsurance = (selectedList, selectedItem) => {
    this.setState(
      {
        requestinfofilter: this.state.requestinfos,
        selectedFieldInsurance: selectedList,
      },
      () => {
        this.filterList();
      }
    );
  };

  onRemoveOptionFieldInsurance = (selectedList, removedItem) => {
    this.setState(
      {
        requestinfofilter: this.state.requestinfos,
        selectedFieldInsurance: selectedList,
      },
      () => {
        this.filterList();
      }
    );
  };

  onSelectOptionCompany = (selectedList, selectedItem) => {
    this.setState(
      {
        requestinfofilter: this.state.requestinfos,
        selectedCompany: selectedList,
      },
      () => {
        this.filterList();
      }
    );
  };

  onRemoveOptionCompany = (selectedList, removedItem) => {
    this.setState(
      {
        requestinfofilter: this.state.requestinfos,
        selectedCompany: selectedList,
      },
      () => {
        this.filterList();
      }
    );
  };

  onSelectOptionCity = (selectedList, selectedItem) => {
    this.setState(
      {
        requestinfofilter: this.state.requestinfos,
        selectedCity: selectedList,
      },
      () => {
        this.filterList();
      }
    );
  };

  onRemoveOptionCity = (selectedList, removedItem) => {
    this.setState(
      {
        requestinfofilter: this.state.requestinfos,
        selectedCity: selectedList,
      },
      () => {
        this.filterList();
      }
    );
  };

  onSelectOptionState = (selectedList, selectedItem) => {
    this.setState(
      {
        requestinfofilter: this.state.requestinfos,
        selectedState: selectedList,
      },
      () => {
        this.getOptionFilterCity();
        this.filterList();
      }
    );
  };

  onRemoveOptionState = (selectedList, removedItem) => {
    this.setState(
      {
        requestinfofilter: this.state.requestinfos,
        selectedState: selectedList,
      },
      () => {
        this.getOptionFilterCity();
        this.filterList();
      }
    );
  };

  handleChangeFilterMobileAgent = (event) => {
    this.setState({ mobileAgentFilter: event.target.value }, () => {
      this.filterList();
    });
  };

  handleChangeFilterMobileUser = (event) => {
    this.setState({ mobileUsertFilter: event.target.value }, () => {
      this.filterList();
    });
  };
  handleChangeFilterRequestId = (event) => {
    this.setState({ requestIdFilter: event.target.value }, () => {
      this.filterList();
    });
  };

  setImageModel = (image, largimage, desc) => {
    console.log("dasdasd");
    this.setState({
      urlToLargeImageFile: largimage,
      urlToHugeImageFile: image,
      descImageFile: desc,
      openImageBox: true,
    });
  };
  closeLightbox = () => {
    this.setState({
      openImageBox: false,
    });
  };

  filterList = () => {
    const {
      requestinfos,
      mobileAgentFilter,
      mobileUsertFilter,
      requestIdFilter,
      selectedFieldInsurance,
      selectedCompany,
      selectedCity,
      selectedState,
      selectedDayEnd,
      selectedDayStart,
    } = this.state;
    var timeStampStart = parseInt(
      Moment(
        JDate.toGregorian(
          selectedDayStart.year,
          selectedDayStart.month,
          selectedDayStart.day
        )
      ).format("x"),
      0
    );
    var timeStampEnd = parseInt(
      Moment(
        JDate.toGregorian(
          selectedDayEnd.year,
          selectedDayEnd.month,
          selectedDayEnd.day
        )
      ).format("x"),
      0
    );

    var i, temparray, temparray2, staterequest_last_timestamp;
    temparray = requestinfos;
    temparray2 = [];
    for (i = 0; i < temparray.length; i++) {
      staterequest_last_timestamp = parseInt(
        Moment(
          temparray[i].staterequest_last_timestamp,
          "YYYY-M-D HH:mm:ss"
        ).format("x")
      );
      if (
        this.feieldInsuranceExist(
          temparray[i].fieldinsurance_id,
          selectedFieldInsurance
        ) &&
        this.companyExist(temparray[i].request_company_id, selectedCompany) &&
        this.cityExist(temparray[i].agent_city_id, selectedCity) &&
        this.stateExist(temparray[i].agent_state_id, selectedState) &&
        ((mobileAgentFilter !== "" &&
          temparray[i].agent_mobile.includes(mobileAgentFilter)) ||
          mobileAgentFilter === "") &&
        ((mobileUsertFilter !== "" &&
          temparray[i].user_mobile.includes(mobileUsertFilter)) ||
          mobileUsertFilter === "") &&
        ((requestIdFilter !== "" &&
          temparray[i].request_id === requestIdFilter) ||
          requestIdFilter === "") &&
        (staterequest_last_timestamp > timeStampStart || !timeStampStart) &&
        (staterequest_last_timestamp < timeStampEnd || !timeStampEnd)
      ) {
        temparray2.push(temparray[i]);
      }
    }
    this.setState({ requestinfofilter: temparray2 }, () => {});
  };

  feieldInsuranceExist = (fieldinsurance_id, selectedFieldInsurance) => {
    if (selectedFieldInsurance.length === 0) {
      return true;
    } else {
      for (var j = 0; j < selectedFieldInsurance.length; j++) {
        if (fieldinsurance_id === selectedFieldInsurance[j].fieldinsurance_id) {
          return true;
        }
      }
      return false;
    }
  };

  companyExist = (request_company_id, selectedCompany) => {
    if (selectedCompany.length === 0) {
      return true;
    } else {
      for (var j = 0; j < selectedCompany.length; j++) {
        if (request_company_id === selectedCompany[j].company_id) {
          return true;
        }
      }
      return false;
    }
  };

  cityExist = (agent_city_id, selectedCity) => {
    if (selectedCity.length === 0) {
      return true;
    } else {
      for (var j = 0; j < selectedCity.length; j++) {
        if (agent_city_id === selectedCity[j].city_id) {
          return true;
        }
      }
      return false;
    }
  };

  stateExist = (agent_state_id, selectedState) => {
    if (selectedState.length === 0) {
      return true;
    } else {
      for (var j = 0; j < selectedState.length; j++) {
        if (agent_state_id === selectedState[j].state_id) {
          return true;
        }
      }
      return false;
    }
  };

  handleChangePage = (event, number) => {
    this.setState({ page: parseInt(number, 0) }, () => {
      this.getOrder();
    });
  };

  clearDeyEnd = (event) => {
    this.setState({ selectedDayEnd: "" }, () => {
      this.filterList();
    });
  };

  setSelectedDayEnd = (event) => {
    this.setState({ selectedDayEnd: event }, () => {
      this.filterList();
    });
  };

  clearDeyStart = (event) => {
    this.setState({ selectedDayStart: "" }, () => {
      this.filterList();
    });
  };

  setSelectedDayStart = (event) => {
    this.setState({ selectedDayStart: event }, () => {
      this.filterList();
    });
  };

  renderCustomInputEnd = ({ ref }) => (
    <OutlinedInput
      readOnly
      ref={ref} // necessary
      placeholder="انتخاب تاریخ پایان"
      value={
        this.state.selectedDayEnd.year
          ? this.state.selectedDayEnd.year +
            "/" +
            this.state.selectedDayEnd.month +
            "/" +
            this.state.selectedDayEnd.day
          : ""
      }
      style={{
        fontSize: "13px",
        direction: "ltr",
      }}
      className="my-custom-input-class" // a styling class
      endAdornment={
        <InputAdornment position="end">
          <IconButton onClick={this.clearDeyEnd}>
            <HighlightOffIcon />
          </IconButton>
        </InputAdornment>
      }
    />
  );

  renderCustomInputStart = ({ ref }) => (
    <OutlinedInput
      readOnly
      ref={ref} // necessary
      placeholder="انتخاب تاریخ شروع"
      style={{
        fontSize: "13px",
        direction: "ltr",
      }}
      value={
        this.state.selectedDayStart.year
          ? this.state.selectedDayStart.year +
            "/" +
            this.state.selectedDayStart.month +
            "/" +
            this.state.selectedDayStart.day
          : ""
      }
      className="my-custom-input-class" // a styling class
      endAdornment={
        <InputAdornment position="end">
          <IconButton onClick={this.clearDeyStart}>
            <HighlightOffIcon />
          </IconButton>
        </InputAdornment>
      }
    />
  );

  PrintElem = () => {
    const { archiveDetail } = this.state;
    var request_adderss = null;
    if (archiveDetail["request_adderss"]) {
      request_adderss = archiveDetail["request_adderss"][0];
    }
    var request_ready = null;
    if (archiveDetail["request_ready"]) {
      request_ready = archiveDetail["request_ready"][0];
    }
    var mywindow = window.open("", "PRINT", "height=400,width=900");

    mywindow.document.write("<html><head><title>رهنمایه بیمه</title>");
    mywindow.document.write(
      "<style>body{overflow-x:hidden;direction: rtl;},table {  width:100%; text-align: right;}table, th, td {  border: 1px solid black;  border-collapse: collapse;}th, td {  padding: 0px;  text-align: right;}</style>"
    );

    mywindow.document.write("</head><body >");
    mywindow.document.write('<table style="width:100%">');
    mywindow.document.write("<tr>");
    mywindow.document.write("<th><h4>فرستنده</h4></th>");
    mywindow.document.write(
      "<th><h6>شرکت کارگزاری پارسیان لوتوس خاور میانه</h6></th>"
    );
    mywindow.document.write(
      "<th><h6>آدرس:تهران خیابان نلسون ماندلا نبش گلشهر پلاک 191 واحد 303</h6></th>"
    );
    mywindow.document.write("<th><h6>تلفن:02196761900  </h6></th>");
    mywindow.document.write("<th><h6>کد پستی :5612315165 </h6></th>");
    mywindow.document.write("</tr>");

    mywindow.document.write("<tr>");
    mywindow.document.write("<th><h4>گیرنده</h4></th>");
    mywindow.document.write(
      "<th><h6>" +
        archiveDetail["user_name"] +
        " " +
        archiveDetail["user_family"] +
        " </h6></th>"
    );
    mywindow.document.write(
      "<th><h6>" +
        "آدرس:" +
        request_adderss["user_address_state"] +
        "-" +
        request_adderss["user_address_city"] +
        "-" +
        request_adderss["user_address_str"] +
        "</h6></th>"
    );
    mywindow.document.write(
      "<th><h6>" +
        "شماره همراه : " +
        archiveDetail["user_mobile"] +
        "<br/>" +
        "شماره تحویل گیرنده: " +
        request_adderss["user_address_tell"] +
        "</h6></th>"
    );
    mywindow.document.write(
      "<th><h6>کد پستی :" + request_adderss["user_address_code"] + "</h6></th>"
    );
    mywindow.document.write("</tr>");

    mywindow.document.write("</table>");
    mywindow.document.write(
      "<h6>شماره سفارش :" +
        archiveDetail["request_id"] +
        "  بیمه نامه   " +
        archiveDetail["request_fieldinsurance_fa"] +
        "   ،شرکت:" +
        archiveDetail["company_name"] +
        "   ،شماره بیمه نامه:" +
        request_ready["requst_ready_num_ins"] +
        "</h6>"
    );
    mywindow.document.write("<hr>");

    mywindow.document.write("</body></html>");
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();

    return true;
  };

  PrintElems = () => {
    const { requestinfofilter } = this.state;

    var mywindow = window.open("", "PRINT", "height=400,width=900");

    mywindow.document.write("<html><head><title>رهنمایه بیمه</title>");
    mywindow.document.write(
      "<style>body{overflow-x:hidden;direction: rtl;},table {  width:100%; text-align: right;}table, th, td {  border: 1px solid black;  border-collapse: collapse;}th, td {  padding: 0px;  text-align: right;}</style>"
    );

    mywindow.document.write("</head><body >");
    for (var i = 0; i < this.state.requestinfofilter.length; i++) {
      var archiveDetail = requestinfofilter[i];
      var request_ready = null;
      if (archiveDetail["request_ready"]) {
        request_ready = archiveDetail["request_ready"][0];
      }
      var request_adderss = null;
      if (archiveDetail["request_adderss"]) {
        request_adderss = archiveDetail["request_adderss"][0];
      }

      mywindow.document.write('<table style="width:100%">');
      mywindow.document.write("<tr>");
      mywindow.document.write("<th><h4>فرستنده</h4></th>");
      mywindow.document.write(
        "<th><h6>شرکت کارگزاری پارسیان لوتوس خاور میانه</h6></th>"
      );
      mywindow.document.write(
        "<th><h6>آدرس:تهران خیابان نلسون ماندلا نبش گلشهر پلاک 191 واحد 303</h6></th>"
      );
      mywindow.document.write("<th><h6>تلفن:02196761900  </h6></th>");
      mywindow.document.write("<th><h6>کد پستی :5612315165 </h6></th>");
      mywindow.document.write("</tr>");

      mywindow.document.write("<tr>");
      mywindow.document.write("<th><h4>گیرنده</h4></th>");
      mywindow.document.write(
        "<th><h6>" +
          archiveDetail["user_name"] +
          " " +
          archiveDetail["user_family"] +
          " </h6></th>"
      );
      mywindow.document.write(
        "<th><h6>" +
          "آدرس:" +
          request_adderss["user_address_state"] +
          "-" +
          request_adderss["user_address_city"] +
          "-" +
          request_adderss["user_address_str"] +
          "</h6></th>"
      );
      mywindow.document.write(
        "<th><h6>" +
          "شماره همراه : " +
          archiveDetail["user_mobile"] +
          "<br/>" +
          "شماره تحویل گیرنده: " +
          request_adderss["user_address_tell"] +
          "</h6></th>"
      );
      mywindow.document.write(
        "<th><h6>کد پستی :" +
          request_adderss["user_address_code"] +
          "</h6></th>"
      );
      mywindow.document.write("</tr>");
      mywindow.document.write("</table>");
      mywindow.document.write(
        "<h6>شماره سفارش :" +
          archiveDetail["request_id"] +
          "  بیمه نامه   " +
          archiveDetail["request_fieldinsurance_fa"] +
          "   ،شرکت:" +
          archiveDetail["company_name"] +
          "   ،شماره بیمه نامه:" +
          request_ready["requst_ready_num_ins"] +
          "</h6>"
      );
      mywindow.document.write("<hr>");
    }
    mywindow.document.write("</body></html>");
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    // mywindow.close();

    return true;
  };

  render() {
    const { classes } = this.props;
    const {
      urlToHugeImageFile,
      descImageFile,
      urlToLargeImageFile,
      percent,
      loading,
      resource,
      selectedCity2,
      optionCity2,
      optionState2,
      selectedState2,
      optionModeDelivery,
      selectedModeDelivery,
      selectedDayEnd,
      mobileAgentFilter,
      mobileUsertFilter,
      requestIdFilter,
      selectedDayStart,
      order,
      orderBy,
      archiveDetail,
      showPaperDetail,
      okstatus,
      errstr,
      redirect,
      requestinfofilter,
      rowsPerPage,
      arrCount,
      page,
    } = this.state;
    var request_adderss = null;
    var request_ready_image_tb = null;
    var request_ready_file_tb = null;
    var request_ready = null;
    if (archiveDetail["request_adderss"]) {
      request_adderss = archiveDetail["request_adderss"][0];
    }
    console.log(archiveDetail);
    var request_delivered = null;
    if (archiveDetail["request_delivered"]) {
      request_delivered = archiveDetail["request_delivered"][0];
    }
    console.log(request_delivered);

    if (archiveDetail["request_ready"]) {
      request_ready = archiveDetail["request_ready"][0];
      if (request_ready) {
        if (request_ready["request_ready_image_tb"]) {
          request_ready_image_tb = request_ready["request_ready_image_tb"];
        }
        if (request_ready["request_ready_file_tb"]) {
          request_ready_file_tb = request_ready["request_ready_file_tb"];
        }
      }
    }
    if (redirect) {
      return <Redirect to="/" />;
    } else {
      return (
        <div className={classes.paperrtl} dir="ltr">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Container maxWidth="lg">
                <Paper
                  style={{ padding: "15px", direction: "rtl" }}
                  className={classes.root}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <Typography variant="h7">
                          {"تاریخ شروع  "}
                          <Calendar
                            renderInput={this.renderCustomInputStart} // render a custom input
                            value={selectedDayStart}
                            onChange={this.setSelectedDayStart}
                            locale="fa"
                            shouldHighlightWeekends
                          />
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={6}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <Typography variant="h7">
                          {"تاریخ پایان  "}
                          <Calendar
                            renderInput={this.renderCustomInputEnd} // render a custom input
                            value={selectedDayEnd}
                            onChange={this.setSelectedDayEnd}
                            locale="fa"
                            shouldHighlightWeekends
                          />
                        </Typography>
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <Multiselect
                          style={styleselect}
                          options={this.state.optionFieldInsurance} // Options to display in the dropdown
                          selectedValues={
                            this.state.selectedOptionFieldInsurance
                          } // Preselected value to persist in dropdown
                          onSelect={this.onSelectOptionFieldInsurance} // Function will trigger on select event
                          onRemove={this.onRemoveOptionFieldInsurance} // Function will trigger on remove event
                          displayValue="fieldinsurance_fa" // Property name to display in the dropdown options
                          placeholder="انتخاب رشته"
                          closeIcon="circle2"
                          emptyRecordMsg="فیلد  در دسترس نیست "
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <Multiselect
                          style={styleselect}
                          options={this.state.optionCompany} // Options to display in the dropdown
                          selectedValues={this.state.selectedOptionCompany} // Preselected value to persist in dropdown
                          onSelect={this.onSelectOptionCompany} // Function will trigger on select event
                          onRemove={this.onRemoveOptionCompany} // Function will trigger on remove event
                          displayValue="company_name" // Property name to display in the dropdown options
                          placeholder="انتخاب شرکت"
                          closeIcon="circle2"
                          emptyRecordMsg="فیلد  در دسترس نیست "
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <Multiselect
                          style={styleselect}
                          options={this.state.optionState} // Options to display in the dropdown
                          //selectedValues={selectedOptionState} // Preselected value to persist in dropdown
                          onSelect={this.onSelectOptionState} // Function will trigger on select event
                          onRemove={this.onRemoveOptionState} // Function will trigger on remove event
                          ref={this.multiselectStateRef}
                          displayValue="state_name" // Property name to display in the dropdown options
                          placeholder="استان ها "
                          closeIcon="circle2"
                          emptyRecordMsg="فیلد  در دسترس نیست "
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <Multiselect
                          style={styleselect}
                          options={this.state.optionCity} // Options to display in the dropdown
                          selectedValues={this.state.selectedOptionCity} // Preselected value to persist in dropdown
                          onSelect={this.onSelectOptionCity} // Function will trigger on select event
                          onRemove={this.onRemoveOptionCity} // Function will trigger on remove event
                          displayValue="city_name" // Property name to display in the dropdown options
                          placeholder="انتخاب شهر"
                          closeIcon="circle2"
                          emptyRecordMsg="فیلد  در دسترس نیست "
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <FloatingLabelInput
                        placeholder="همراه نماینده"
                        value={mobileAgentFilter}
                        handleInputt={this.handleChangeFilterMobileAgent}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <FloatingLabelInput
                        placeholder="همراه کاربر"
                        value={mobileUsertFilter}
                        handleInputt={this.handleChangeFilterMobileUser}
                      />
                    </Grid>

                    <Grid item xs={12} sm={2}>
                      <FloatingLabelInput
                        placeholder="شماره سفارش"
                        value={requestIdFilter}
                        handleInputt={this.handleChangeFilterRequestId}
                      />
                    </Grid>

                    <Grid item xs={2}>
                      <Button
                        onClick={this.PrintElems}
                        variant="contained"
                        color="secondary"
                      >
                        <div className="adapter-txtsize">
                          <div>{" چاپ رسیدها "}</div>
                        </div>
                      </Button>
                    </Grid>
                  </Grid>
                </Paper>
              </Container>
            </Grid>

            <Grid item xs={12}></Grid>

            <Grid item xs={12}>
              <Collapse in={showPaperDetail}>
                <Container component="main" maxWidth="lg">
                  <Paper elevation={4} className={classes.root}>
                    <Grid container spacing={3}>
                      <Grid item xs={4}>
                        <div style={{ width: "100%", textAlign: "right" }}>
                          <Typography align="center" variant="h7">
                            {"شماره درخواست: " + archiveDetail["request_id"]}
                          </Typography>
                        </div>
                      </Grid>

                      <Grid item xs={8} sm={4}>
                        <div style={{ width: "100%", textAlign: "center" }}>
                          <Typography align="center" variant="h7">
                            {"رشته بیمه : " +
                              archiveDetail["request_fieldinsurance_fa"]}
                            <img
                              alt=""
                              style={{ height: "30px", width: "atuo" }}
                              src={archiveDetail["fieldinsurance_logo_url"]}
                            />
                          </Typography>
                        </div>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <div style={{ width: "100%", textAlign: "center" }}>
                          <Typography align="center" variant="h7">
                            {"شرکت  : " + archiveDetail["company_name"]}
                            <img
                              alt=""
                              style={{ height: "30px", width: "atuo" }}
                              src={archiveDetail["company_logo_url"]}
                            />
                          </Typography>
                        </div>
                      </Grid>

                      <Grid item xs={12}>
                        <Divider />
                      </Grid>

                      <Grid item xs={12}>
                        {request_adderss ? (
                          <Grid container spacing={3}>
                            <Grid item xs={12}>
                              <Typography variant="h6">
                                {" "}
                                آدرس ارسال بیمه
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography variant="h7">
                                {"شماره همراه: "}
                                {request_adderss["user_address_mobile"]}
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography variant="h7">
                                {"تلفن: "}
                                {request_adderss["user_address_tell"]}
                              </Typography>
                            </Grid>

                            <Grid item xs={3}>
                              <Typography variant="h7">
                                {"استان: "}
                                {request_adderss["user_address_state"]}
                              </Typography>
                            </Grid>
                            <Grid item xs={3}>
                              <Typography variant="h7">
                                {"َشهر: "}
                                {request_adderss["user_address_city"]}
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography variant="h7">
                                {"کد پستی: "}
                                {request_adderss["user_address_code"]}
                              </Typography>
                            </Grid>

                            <Grid item xs={8}>
                              <Typography variant="h7">
                                {"آدرس : "}
                                {request_adderss["user_address_str"]}
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Button
                                onClick={this.PrintElem}
                                variant="contained"
                                color="secondary"
                              >
                                <div className="adapter-txtsize">
                                  <div>{" چاپ رسید ارسال "}</div>
                                </div>
                              </Button>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              {request_ready_image_tb ? (
                                <TableContainer component={Paper}>
                                  <Table
                                    className={classes.table}
                                    aria-label="simple table"
                                  >
                                    <TableHead>
                                      <TableRow>
                                        <TableCell
                                          style={{ minWidth: 60 }}
                                          align="center"
                                        >
                                          نام عکس
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            minWidth: 100,
                                          }}
                                          align="center"
                                        >
                                          توضیحات
                                        </TableCell>
                                        <TableCell
                                          style={{ minWidth: 30 }}
                                          align="center"
                                        >
                                          عکس{" "}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {request_ready_image_tb.map((row) => {
                                        return (
                                          <TableRow key={row.image_name}>
                                            <TableCell align="center">
                                              {" "}
                                              {row.image_name}
                                            </TableCell>
                                            <TableCell align="center">
                                              {row.image_desc}
                                            </TableCell>

                                            <TableCell align="center">
                                              <div
                                                style={{
                                                  width: "100%",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <Avatar
                                                  variant="rounded"
                                                  alt="Remy Sharp"
                                                  src={row.image_tumb_url}
                                                  onClick={() => {
                                                    this.setImageModel(
                                                      row.image_tumb_url,
                                                      row.image_url,
                                                      row.image_name
                                                    );
                                                  }}
                                                />
                                              </div>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : null}
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              {request_ready_file_tb ? (
                                <TableContainer component={Paper}>
                                  <Table
                                    className={classes.table}
                                    aria-label="simple table"
                                  >
                                    <TableHead>
                                      <TableRow>
                                        <TableCell
                                          style={{
                                            minWidth: 100,
                                          }}
                                          align="center"
                                        >
                                          توضیحات
                                        </TableCell>
                                        <TableCell
                                          style={{ minWidth: 30 }}
                                          align="center"
                                        >
                                          لینک دانلود{" "}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {request_ready_file_tb.map((row) => {
                                        return (
                                          <TableRow key={row.request_file_desc}>
                                            <TableCell align="center">
                                              {" "}
                                              {row.request_file_desc}
                                            </TableCell>

                                            <TableCell align="center">
                                              <a href={row.request_file_url}>
                                                دانلود
                                              </a>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : null}
                            </Grid>
                          </Grid>
                        ) : null}
                      </Grid>
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                      <Grid item xs={4}>
                        <div style={{ width: "100%", textAlign: "right" }}>
                          <Typography align="center" variant="h7">
                            {"مشخصات کاربر: " +
                              archiveDetail["user_name"] +
                              " " +
                              archiveDetail["user_family"] +
                              " -  شماره همراه : " +
                              archiveDetail["user_mobile"]}
                          </Typography>
                        </div>
                      </Grid>

                      <Grid item xs={4}>
                        <div style={{ width: "100%", textAlign: "right" }}>
                          <Typography align="center" variant="h7">
                            {"مشخصات نماینده: " +
                              archiveDetail["agent_name"] +
                              " " +
                              archiveDetail["agent_family"] +
                              " -  شماره همراه : " +
                              archiveDetail["agent_mobile"] +
                              " - کد : " +
                              archiveDetail["agent_code"]}
                          </Typography>
                        </div>
                      </Grid>

                      <Grid item xs={4}>
                        <div style={{ width: "100%", textAlign: "right" }}>
                          <Typography align="center" variant="h7">
                            {"استان : " +
                              archiveDetail["agent_state_name"] +
                              "   - شهرستان:  " +
                              archiveDetail["agent_city_name"]}
                          </Typography>
                        </div>
                      </Grid>

                      <Grid item xs={12}>
                        <Divider />
                      </Grid>

                      <Grid item xs={9}></Grid>
                      <Grid item xs={3}>
                        <div style={{ width: "100%", textAlign: "left" }}>
                          <Button onClick={this.hidePaperDetail}>
                            {"مخفی کردن"}
                          </Button>
                        </div>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Typography variant="h6">
                          {"ثبت ارسال بیمه نامه"}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <div>
                          <label className="on">نوع ارسال</label>
                          <Select
                            isSearchable={true}
                            className="adapter-txtsize"
                            placeholder={"نوع ارسال"}
                            value={selectedModeDelivery}
                            onChange={this.handleModeDelivery}
                            options={optionModeDelivery}
                          />
                        </div>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <div>
                          <label className="on">استان</label>
                          <Select
                            isSearchable={true}
                            className="adapter-txtsize"
                            placeholder={"استان"}
                            value={selectedState2}
                            onChange={this.handleState2}
                            options={optionState2}
                          />
                        </div>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <div>
                          <label className="on">شهر</label>
                          <Select
                            isSearchable={true}
                            className="adapter-txtsize"
                            placeholder={"شهر"}
                            value={selectedCity2}
                            onChange={this.handleCity2}
                            options={optionCity2}
                          />
                        </div>
                      </Grid>

                      <Grid item xs={12} sm={8}>
                        <FloatingLabelInput
                          placeholder="توضیحات تحویل "
                          value={resource}
                          handleInputt={this.handleChangeResorce}
                        />
                        <Grid item xs={12}>
                          <Typography variant="h7">
                            {"رسید تحویل بیمه نامه : "}
                          </Typography>
                          {request_delivered === null ? null : (
                            <Avatar
                              variant="rounded"
                              alt="Remy Sharp"
                              src={request_delivered["user_pey_image_turl"]}
                              onClick={() => {
                                this.setImageModel(
                                  request_delivered["user_pey_image_turl"],
                                  request_delivered["user_pey_image_url"],
                                  " رسید تحویل بیمه نامه"
                                );
                              }}
                            />
                          )}
                        </Grid>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <ImageUploader
                          withIcon={true}
                          buttonText="عکس را انتخاب نمایید"
                          onChange={this.onSelectPicRequest}
                          withPreview="true"
                          singleImage="true"
                          imgExtension={[
                            ".jpg",
                            ".jpeg",
                            ".gif",
                            ".png",
                            ".gif",
                          ]}
                          maxFileSize={5242880}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        {loading && (
                          <LinearProgress
                            variant="determinate"
                            value={percent}
                          />
                        )}
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={this.uploadPicDelivery}
                        >
                          ثبت وضعیت تحویل شده به کاربر
                        </Button>
                      </Grid>
                    </Grid>
                  </Paper>
                </Container>
              </Collapse>
            </Grid>
            <Grid item xs={12}>
              <Container maxWidth="lg">
                <Paper className={classes.root}>
                  <ExcelFile
                    element={
                      <Button variant="outlined" color="primary">
                        {" "}
                        {"اکسل "}
                      </Button>
                    }
                  >
                    <ExcelSheet data={requestinfofilter} name="نمایندگان">
                      <ExcelColumn label="آی دی سفارش" value="request_id" />
                      <ExcelColumn label="شرکت" value="company_name" />
                      <ExcelColumn
                        label="رشته بیمه ای"
                        value="request_fieldinsurance_fa"
                      />
                      <ExcelColumn
                        label="توضیحات"
                        value="request_description"
                      />
                      <ExcelColumn
                        label="اخرین وضعیت"
                        value="request_last_state_name"
                      />
                      <ExcelColumn
                        label="مبلغ پرداخت شده"
                        value="user_pey_amount"
                      />
                      <ExcelColumn label="مبلغ نقدی" value="user_pey_cash" />
                      <ExcelColumn label="نام کاربر" value="user_name" />
                      <ExcelColumn
                        label="نام خانوادگی کاربر"
                        value="user_family"
                      />
                      <ExcelColumn label="همراه کاربر " value="user_mobile" />
                      <ExcelColumn label="آی دی" value="agent_id" />
                      <ExcelColumn label="جنسیت" value="agent_gender" />
                      <ExcelColumn label="نام" value="agent_name" />
                      <ExcelColumn label="نام خانوادگی" value="agent_family" />
                      <ExcelColumn label="شماره همراه" value="agent_mobile" />
                      <ExcelColumn label="تلفن دفتر" value="agent_tell" />
                      <ExcelColumn label="ایمیل" value="agent_email" />
                      <ExcelColumn
                        label="تلفن ضروری"
                        value="agent_required_phone"
                      />
                      <ExcelColumn label="استان " value="agent_state_name" />
                      <ExcelColumn label="شهر " value="agent_city_name" />
                      <ExcelColumn label="نام محله" value="agent_sector_name" />
                      <ExcelColumn label="آدرس" value="agent_address" />
                      <ExcelColumn label="نام بانک" value="agent_bankname" />
                      <ExcelColumn label="شماره حساب" value="agent_banknum" />
                      <ExcelColumn label="شماره شبا" value="agent_banksheba" />
                      <ExcelColumn
                        label="شرکت بیمه"
                        value="agent_company_name"
                      />
                      <ExcelColumn label="کد نمایندگی" value="agent_code" />
                    </ExcelSheet>
                  </ExcelFile>

                  <TableContainer dir="rtl">
                    <Table aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          <TableCell
                            key={"request_id"}
                            align={"center"}
                            style={{ minWidth: 30 }}
                            sortDirection={
                              orderBy === "request_id" ? order : false
                            }
                          >
                            {" شماره سفارش"}
                            <TableSortLabel
                              active={orderBy === "request_id"}
                              direction={
                                orderBy === "request_id" ? order : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler("request_id");
                              }}
                            ></TableSortLabel>
                          </TableCell>

                          <TableCell
                            key={"request_company_id"}
                            align={"center"}
                            style={{ minWidth: 60 }}
                          >
                            {"شرکت بیمه"}
                            <TableSortLabel
                              active={orderBy === "request_company_id"}
                              direction={
                                orderBy === "request_company_id" ? order : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler("request_company_id");
                              }}
                            ></TableSortLabel>
                          </TableCell>

                          <TableCell
                            key={"request_fieldinsurance_fa"}
                            align={"center"}
                            style={{ minWidth: 60 }}
                          >
                            {"رشته بیمه"}
                            <TableSortLabel
                              active={orderBy === "request_fieldinsurance_fa"}
                              direction={
                                orderBy === "request_fieldinsurance_fa"
                                  ? order
                                  : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler(
                                  "request_fieldinsurance_fa"
                                );
                              }}
                            ></TableSortLabel>
                          </TableCell>

                          <TableCell
                            key={"agent_state_id"}
                            align={"center"}
                            style={{ minWidth: 60 }}
                          >
                            {"استان"}
                            <TableSortLabel
                              active={orderBy === "agent_state_id"}
                              direction={
                                orderBy === "agent_state_id" ? order : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler("agent_state_id");
                              }}
                            ></TableSortLabel>
                          </TableCell>

                          <TableCell
                            key={"agent_city_id"}
                            align={"center"}
                            style={{ minWidth: 60 }}
                          >
                            {"شهر "}
                            <TableSortLabel
                              active={orderBy === "agent_city_id"}
                              direction={
                                orderBy === "agent_city_id" ? order : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler("agent_city_id");
                              }}
                            ></TableSortLabel>
                          </TableCell>

                          <TableCell
                            key={"agent_mobile"}
                            align={"center"}
                            style={{ minWidth: 60 }}
                          >
                            {"همراه نماینده"}
                            <TableSortLabel
                              active={orderBy === "agent_mobile"}
                              direction={
                                orderBy === "agent_mobile" ? order : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler("agent_mobile");
                              }}
                            ></TableSortLabel>
                          </TableCell>

                          <TableCell
                            key={"user_mobile"}
                            align={"center"}
                            style={{ minWidth: 60 }}
                          >
                            {"همراه کاربر"}
                            <TableSortLabel
                              active={orderBy === "user_mobile"}
                              direction={
                                orderBy === "user_mobile" ? order : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler("user_mobile");
                              }}
                            ></TableSortLabel>
                          </TableCell>

                          <TableCell
                            key={"staterequest_last_timestamp"}
                            align={"center"}
                            style={{ minWidth: 60 }}
                          >
                            {"تاریخ آخرین وضعیت"}
                            <TableSortLabel
                              active={orderBy === "staterequest_last_timestamp"}
                              direction={
                                orderBy === "staterequest_last_timestamp"
                                  ? order
                                  : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler(
                                  "staterequest_last_timestamp"
                                );
                              }}
                            ></TableSortLabel>
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {requestinfofilter.slice(0, rowsPerPage).map((row) => {
                          var varmoment = Moment(
                            row["staterequest_last_timestamp"],
                            "YYYY-M-D HH:mm:ss"
                          );
                          var date = new Date(parseInt(varmoment.format("x")));
                          var jdate1 = new JDate(date);
                          var dateMinStr =
                            jdate1.format("YYYY/MM/DD") +
                            "ساعت " +
                            varmoment.format("HH:mm");

                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={row["request_id"]}
                              value={row}
                              onClick={(e) => {
                                this.handleSelectRows(e, row);
                              }}
                            >
                              <TableCell key={"request_id"} align={"center"}>
                                {row["request_id"]}
                              </TableCell>

                              <TableCell
                                key={"request_company_id"}
                                align={"center"}
                              >
                                <img
                                  alt=""
                                  style={{ height: "30px", width: "atuo" }}
                                  src={row["company_logo_url"]}
                                />

                                {row["company_name"]}
                              </TableCell>

                              <TableCell
                                key={"request_fieldinsurance_fa"}
                                align={"center"}
                              >
                                <img
                                  alt=""
                                  style={{ height: "30px", width: "atuo" }}
                                  src={row["fieldinsurance_logo_url"]}
                                />

                                {row["request_fieldinsurance_fa"]}
                              </TableCell>

                              <TableCell
                                key={"agent_state_name"}
                                align={"center"}
                              >
                                {row["agent_state_name"]}
                              </TableCell>

                              <TableCell
                                key={"agent_city_name"}
                                align={"center"}
                              >
                                {row["agent_city_name"]}
                              </TableCell>

                              <TableCell key={"agent_mobile"} align={"center"}>
                                {row["agent_mobile"]}
                              </TableCell>

                              <TableCell key={"user_mobile"} align={"center"}>
                                {row["user_mobile"]}
                              </TableCell>

                              <TableCell
                                key={"staterequest_last_timestamp"}
                                align={"center"}
                              >
                                {dateMinStr}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[
                      10, 25, 100, 1000, 5000, 10000, 100000,
                    ]}
                    component="div"
                    count={arrCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  />
                </Paper>
                {this.state.openImageBox && (
                  <Lightbox
                    medium={urlToLargeImageFile}
                    large={urlToHugeImageFile}
                    alt={descImageFile}
                    onClose={this.closeLightbox}
                    showRotate={true}
                    hideZoom={false}
                  />
                )}
              </Container>
            </Grid>
          </Grid>

          {okstatus ? (
            <Alert severity="success">
              <AlertTitle>پیام</AlertTitle>
              {errstr}
            </Alert>
          ) : null}
        </div>
      );
    }
  }
}

export default withStyles(styles)(ChangeSendRequestPosted);
